<template>
    <div id="main-page">
        <div class="container">
          <app-bar
            title="Pilih Cabang"
            :previousLink="previousLink" />
          <div class="row">
            <div class="col-md-4">
              <div class="input-group mb-3 rounded-pill">
                <input
                  type="text"
                  class="form-control bg-transparent"
                  placeholder="Cari cabang...."
                  name="search"
                  v-model="keyword"
                  autocomplete="off">
                <span class="input-group-text bg-transparent border-0">
                    <div
                      class="box-icon"
                      type="button"
                      @click="keyword = ''"
                    >
                      <i class="ri-close-circle-fill fs-14 color-neutral-700"></i>
                    </div>
                </span>
                </div>
            </div>
          </div>
          <Loading v-if="loading.listBranchPoli && filteredBranchPoli.length < 1" />
          <div
            v-else-if="filteredBranchPoli.length">
            <div class="row">
              <div
                v-for="(data, index) in filteredBranchPoli"
                class="col-md-4 mb-md-3"
                :key="index"
                @click="changeBranch(data)">
                <a
                  href="javascript:void(0)"
                  class="branch rounded d-flex justify-content-between align-items-center py-2 mb-md-2"
                  >
                  <div class="branch-group d-flex align-items-center">
                    <div
                      class="icon-wrapper bg-neutral-200 d-flex align-items-center justify-content-center rounded-circle"
                      :class="{ [data.id === selectedBranchPoli?.id ? 'bg-primary' : '']: true }"
                    >
                      <img
                        :src="data.id === selectedBranchPoli?.id ? require('@/assets/icon/location-white.png') : require('@/assets/icon/location.png')"
                        alt=""
                      />
                    </div>
                    <div class="branch-group-info d-flex flex-column ps-3">
                      <p class="branch-name fw-bold fs-14 lh-18 color-neutral-900 mb-0">
                        {{ data.nama }}
                      </p>
                      <p class="branch-address fw-400 fs-12 lh-14 mb-0 color-neutral-600">
                        {{ data.alamat }}
                      </p>
                      <small
                        class="branch-phone fw-400 fs-12 lh-14 color-neutral-600">
                        {{ data.tlp || '-' }}
                      </small>
                    </div>
                  </div>
                  <div class="branch-group d-flex align-items-center">
                    <input
                      type="radio"
                      name="branch"
                      class="input-select-branch"
                      :checked="data.id === selectedBranchPoli?.id"
                      @click="changeBranch(data)"
                    />
                  </div>
                </a>
              </div>
            </div>
            <div class="bottom-bar pb-md-3 p-2 px-md-0">
              <div class="row">
                <div class="col-md-4">
                  <button
                    @click="submit"
                    class="btn btn-orange text-white w-100 pt-2 pb-2"
                    :class="{
                      disabled: !selectedBranchPoli || !isSelectedBranchAvailable()
                    }"
                  >
                    Lanjutkan
                  </button>
                  <!-- <router-link
                    :to="nextLink"
                    class="btn btn-orange text-white w-100 pt-2 pb-2"
                    :class="{
                      disabled: !selectedBranchPoli
                    }">
                    Lanjutkan
                  </router-link> -->
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="not-found d-flex flex-column text-center pb-5 pt-5">
            <div class="image-wrapper">
              <img src="@/assets/icon/empty.png" alt="">
            </div>
            <p class="text-title-active fw-bold fs-18 lh-28">
              Tidak ada hasil ditemukan
            </p>
            <div class="text-body-light d-flex justify-content-center">
              <p class="fw-400 fs-14 lh-24 mb-0">Maaf cabang yang anda cari tidak ditemukan, silahkan coba layanan lainnya.</p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import AppBar from '@/components/AppBar'
import Loading from '@/components/utility/Loading'
import { computed, nextTick, onMounted, ref } from 'vue'
import { title } from '@/core/page'
import { useRouter, useRoute } from 'vue-router'
import { showNotif } from '@/core/utility'
import { selectedBranchPoli, loading, listBranchPoli, selectedPoli, getListBranchPoli } from '@/core/poli'

export default {
  components: {
    AppBar, Loading
  },
  setup () {
    const keyword = ref('')
    const router = useRouter()
    const route = useRoute()
    const previousLink = computed(() => {
      if (route.query && route.query.poli) {
        return { name: 'CheckoutPoli', query: { ...route.query } }
      }
      return { name: 'SelectPoli' }
    })

    const filteredBranchPoli = computed(() => {
      return listBranchPoli.value ? listBranchPoli.value.filter((data) => {
        return keyword.value.toLowerCase().split(' ').every(v => data.nama.toLowerCase().includes(v))
      }) : []
    })

    const isSelectedBranchAvailable = () => {
      let isEligible = false
      for (let i = 0; i < filteredBranchPoli.value.length; i++) {
        if (filteredBranchPoli.value[i].id === selectedBranchPoli?.value?.id) {
          isEligible = true
          break
        }
      }
      return isEligible
    }

    const submit = async () => {
      // pastikan branch yg dipilih available
      if (!isSelectedBranchAvailable()) {
        return showNotif({
          status: 'error',
          message: 'Silahkan pilih cabang terlebih dahulu'
        })
      }

      // lanjut ke page selanjutnya
      router.push({
        name: 'CheckoutPoli',
        query: { ...route.query, cabang: selectedBranchPoli.value.id }
      })
    }

    const changeBranch = async (newBranch) => {
      // update branch sekarang
      selectedBranchPoli.value = newBranch
    }

    onMounted(() => {
      if (!selectedPoli.value) {
        return router.push({
          name: 'SelectPoli'
        })
      }

      getListBranchPoli()

      nextTick(() => {
        title.value = 'Pilih Cabang'
      })
    })

    return {
      loading,
      filteredBranchPoli,
      keyword,
      changeBranch,
      submit,
      isSelectedBranchAvailable,
      selectedBranchPoli,
      previousLink
    }
  }
}
</script>

<style lang="scss" scoped>
#main-page {
  @media (max-width: 520px) {
    padding-bottom: 3.25rem;
  }
}

.bottom-bar {
  @media (max-width: 520px) {
    background-color: white;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid rgb(240, 240, 240);
  }
}

.input-group {
  border: 1px solid #E2E8F0;

  .form-control, .input-group-text {
    height: 34px;
  }

  .form-control:focus{
    box-shadow: none;
  }

  .form-control::placeholder {
    color: #A0AEC0;
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
  }
}

.branch {
  box-shadow: 0px -1px 0px 0px #F2F2F2CC inset;

  .icon-wrapper {
    width: 48px;
    height: 48px;
  }

  .branch-group-info {
    gap: 4px;

    .branch-address {
      @media (max-width: 540px) {
        display: block;
        width: 239px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .input-select-branch {
    width: 24px;
    height: 24px;
  }

  .input-select-branch:checked {
    accent-color: #007A98;
  }
}

.not-found {
  .image-wrapper {
    margin-bottom: 24px;
  }

  .text-title-active {
    margin-bottom: 4px;
  }

  .text-body-light p {
    width: 286px;
  }
}
</style>
